import { render, staticRenderFns } from "./DecommissionCamera.vue?vue&type=template&id=0cb57db0"
import script from "./DecommissionCamera.vue?vue&type=script&lang=js"
export * from "./DecommissionCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports